(() => {
  if (window.TFIBCartCrossSellLoaded) return;
  window.TFIBCartCrossSellLoaded = true;

  const BUNDLE_HANDLE = 'complete-oral-care-routine';

  const ORAL_CARE_KEYWORDS = [
    'floss',
    'toothbrush',
    'toothpaste',
    'oral care',
    'tanitabs'
  ];

  function isOralCareItem(item) {
    const title = (item.product_title || item.title || '').toLowerCase();

    return ORAL_CARE_KEYWORDS.some(keyword =>
      title.includes(keyword)
    );
  }

  async function loadCartCrossSell() {
    const container = document.getElementById('TfibCartCrossSell');
    if (!container) return;

    const productId = container.dataset.productId;
    const target = container.querySelector(
      '.tfib-cart-cross-sell__products'
    );

    if (!target) return;

    try {
      const requests = [
        fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        }),
        fetch(`/products/${BUNDLE_HANDLE}.js`, {
          headers: {
            Accept: 'application/json'
          }
        })
      ];

      if (productId) {
        requests.push(
          fetch(
            `/recommendations/products.json?product_id=${productId}&limit=4&intent=complementary`
          )
        );
      }

      const responses = await Promise.all(requests);

      const cartResponse = responses[0];
      const bundleResponse = responses[1];
      const recommendationsResponse = responses[2];

      if (!cartResponse.ok || !bundleResponse.ok) {
        throw new Error('Unable to load cart cross-sell data');
      }

      const cartData = await cartResponse.json();
      const bundleData = await bundleResponse.json();

      let recommendationsData = {
        products: []
      };

      if (
        recommendationsResponse &&
        recommendationsResponse.ok
      ) {
        recommendationsData =
          await recommendationsResponse.json();
      }

      const cartProductIds = new Set(
        cartData.items.map(item => Number(item.product_id))
      );

      const bundleAlreadyInCart =
        cartProductIds.has(Number(bundleData.id));

      const hasOralCareItem =
        cartData.items.some(item => isOralCareItem(item));

      const recommendationLimit =
        window.innerWidth <= 749 ? 1 : 2;

      let products = [];

      if (
        hasOralCareItem &&
        !bundleAlreadyInCart &&
        bundleData.available !== false
      ) {
        products.push(bundleData);
      }

      const normalRecommendations =
        (recommendationsData.products || [])
          .filter(product => {
            return (
              !cartProductIds.has(Number(product.id)) &&
              Number(product.id) !== Number(bundleData.id) &&
              product.available !== false
            );
          });

      products = [
        ...products,
        ...normalRecommendations
      ].slice(0, recommendationLimit);

      if (!products.length) {
        container.style.display = 'none';
        return;
      }

      container.style.display = '';

      target.innerHTML = products
        .map(product => {
          const variant =
            product.variants &&
            product.variants[0];

          if (!variant) return '';

          const price = new Intl.NumberFormat(
            'en-CA',
            {
              style: 'currency',
              currency: 'CAD'
            }
          ).format(variant.price / 100);

          const safeTitle =
            product.title.replace(/"/g, '&quot;');

          const productUrl =
            product.url ||
            `/products/${product.handle}`;

          const isBundle =
            product.handle === BUNDLE_HANDLE;

          const action = isBundle
            ? `
              <a
                href="${productUrl}"
                class="tfib-cart-cross-sell__choose"
              >
                Choose options
              </a>
            `
            : `
              <button
                type="button"
                class="tfib-cart-cross-sell__add"
                data-variant-id="${variant.id}"
              >
                + Add
              </button>
            `;

          return `
            <div class="tfib-cart-cross-sell__item">

              <a
                href="${productUrl}"
                class="tfib-cart-cross-sell__image-link"
              >
                <img
                  src="${product.featured_image}"
                  alt="${safeTitle}"
                  loading="lazy"
                  class="tfib-cart-cross-sell__image"
                >
              </a>

              <div class="tfib-cart-cross-sell__content">

                <a
                  href="${productUrl}"
                  class="tfib-cart-cross-sell__name"
                >
                  ${product.title}
                </a>

                <div class="tfib-cart-cross-sell__bottom">

                  <span class="tfib-cart-cross-sell__price">
                    ${price}
                  </span>

                  ${action}

                </div>

              </div>

            </div>
          `;
        })
        .join('');

    } catch (error) {
      console.error('TFIB cross-sell:', error);
      container.style.display = 'none';
    }
  }

  async function addCrossSellProduct(button) {
    const variantId = button.dataset.variantId;

    if (!variantId || button.disabled) return;

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const cartDrawer =
        document.querySelector('cart-drawer');

      if (!cartDrawer) {
        throw new Error('Cart drawer not found');
      }

      const sections = cartDrawer
        .getSectionsToRender()
        .map(section => section.id);

      const response = await fetch(
        window.routes?.cart_add_url ||
        '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ],
            sections,
            sections_url:
              window.location.pathname
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add product'
        );
      }

      cartDrawer.renderContents(data);

      setTimeout(() => {
        loadCartCrossSell();
      }, 250);

    } catch (error) {
      console.error('TFIB AJAX add:', error);

      button.disabled = false;
      button.textContent = 'Try again';

      setTimeout(() => {
        button.textContent = originalText;
      }, 1800);
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(
      '.tfib-cart-cross-sell__add'
    );

    if (!button) return;

    event.preventDefault();
    addCrossSellProduct(button);
  });

  document.addEventListener(
    'DOMContentLoaded',
    loadCartCrossSell
  );

  document.addEventListener(
    'shopify:section:load',
    loadCartCrossSell
  );

  window.TFIBLoadCartCrossSell =
    loadCartCrossSell;

  document.addEventListener('click', event => {
    const option = event.target.closest(
      '.tfib-quantity-upsell__option'
    );

    if (!option) return;

    const wrapper =
      option.closest('.tfib-quantity-upsell');

    if (!wrapper) return;

    const sectionId =
      wrapper.dataset.sectionId;

    const quantityInput =
      document.getElementById(
        `Quantity-${sectionId}`
      );

    if (!quantityInput) return;

    const qty =
      Number(option.dataset.qty);

    if (!qty) return;

    quantityInput.value = qty;

    quantityInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

    wrapper
      .querySelectorAll(
        '.tfib-quantity-upsell__option'
      )
      .forEach(button => {
        button.classList.remove('is-active');
      });

    option.classList.add('is-active');
  });
    const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer) {
    let tfibCrossSellTimer;

    const observer = new MutationObserver(mutations => {
      const shouldReload = mutations.some(mutation => {
        const target = mutation.target;

        if (
          target instanceof Element &&
          target.closest('.tfib-cart-cross-sell__products')
        ) {
          return false;
        }

        return true;
      });

      if (!shouldReload) return;

      clearTimeout(tfibCrossSellTimer);

      tfibCrossSellTimer = setTimeout(() => {
        loadCartCrossSell();
      }, 250);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
})();